import { BookOpen } from 'lucide-react';
import type { KnowledgeCitation } from '../../../src/application/knowledge/notes';
import { useAgentName } from '../agent-name';
import './knowledge-cited.css';

const scopeLabel: Record<KnowledgeCitation['scope'], string> = { customer: 'this customer', segment: 'this tier', org: 'every customer' };

/** The Knowledge notes a draft was written with (#207), cited on its card. Renders nothing when there are none. */
export function KnowledgeCited({ cited }: { cited: KnowledgeCitation[] | undefined }) {
  const agent = useAgentName();
  if (!cited?.length) return null;
  return <div className="knowledge-cited" aria-label="Knowledge used">
    <span className="eyebrow"><BookOpen size={13} aria-hidden /> KNOWLEDGE {agent.toUpperCase()} USED</span>
    <ul>{cited.map(k => <li key={k.id}><a href={`#policy?knowledge=${encodeURIComponent(k.id)}`}>{k.title}</a>
      <small> · {scopeLabel[k.scope]} · v{k.version}</small></li>)}</ul>
  </div>;
}
